import { Breadcrumb, ConfigProvider, Form, Input, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import CustomButton from '../../../Components/CustomButton'
import { RouterKeys } from '../../../Routes/RouterKeys';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Endpoints } from '../../../Utils/EndPoints';
import { useDynamicMutationMutation } from '../../../redux/service/apiSlice';
import { toast } from 'react-toastify';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { AuthData } from '../../../redux/slices/authSlice';

function EditProfile() {

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);


    const FileUrl = process.env.REACT_APP_FILE_URL
    const adminData = useSelector((state) => state?.auth?.auth_data)
    const adminPic = useSelector((state) => state?.auth?.auth_data?.profile_pic)

    const [UpdateProfileFunc, { isLoading: Update }] = useDynamicMutationMutation();




    const onFinish = async (values) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('first_name', values.firstName);
        formData.append('last_name', values.lastName);
        formData.append('email', values.email);
        if (fileList.length > 0 && fileList[0].originFileObj) {
            formData.append('profile_pic', fileList[0].originFileObj);
        }
        try {
            const { data, error, } = await UpdateProfileFunc({
                endpoint: Endpoints.NON_AUTH.UPDATE_PROFILE,
                method: 'PUT',
                body: formData,
            });
            console.log('Profile Update data', data)
            if (data) {
                toast.success('Profile Data is Updated Successfully', data?.message);

                // Update Redux store with the new data
                dispatch(AuthData({
                    first_name: data?.data?.first_name,
                    last_name: data?.data?.last_name,
                    email: data?.data?.email,
                    profile_pic: data?.data?.profile_pic || adminPic, // Use the new profile pic URL from the API response
                }));

                navigate(RouterKeys.NON_Auth.DASHBOARD);
            } else {
                toast.error(error?.data?.message);
            }
        } catch (error) {
            toast.error(error.message || 'An unexpected error occurred.');
        }
        finally {
            setLoading(false); // Set loading to false after the request finishes
        }

    };

    useEffect(() => {
        form.setFieldsValue({
            firstName: adminData?.first_name,
            lastName: adminData?.last_name,
            email: adminData?.email,
        });
        // Pre-fill the fileList with the existing profile picture
        if (adminPic) {
            setFileList([
                {
                    uid: '-1',
                    name: 'profile_pic',
                    status: 'done',
                    url: `${FileUrl}${adminPic}`,
                },
            ]);
        }
    }, [adminData]);


    //handle image shown in update file 
    const handleChange = ({ fileList: newFileList }) => { setFileList(newFileList) };

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        }
    };

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    return (
        <>
            <ConfigProvider
                theme={{
                    components: {
                        Breadcrumb: {
                            itemColor: 'black', // Custom color for breadcrumb items
                            separatorColor: 'black', // Custom color for separator

                        },
                    },
                }}

            >
                <div className="mb-4">
                    <Breadcrumb
                        items={[
                            {
                                title: <span className="text-black-200 text-h2 font-bold cursor-pointer " onClick={()=>{navigate(RouterKeys.NON_Auth.MY_PROFILE);}} >Profile</span>,
                            },
                            {
                                title: <span className="text-brown-200 text-h2 font-bold">Edit Profile</span>
                            },
                        ]}
                        separator={<span className="text-h2 text-black-200 font-bold">/</span>}
                    />
                </div>
            </ConfigProvider>

            <div className='rounded-lg shadow-cardCustom w-full md:w-1/2 my-4'>
                <Form
                    layout="vertical"
                    autoComplete="off"
                    requiredMark={false}
                    onFinish={onFinish}
                    form={form}
                    className="p-5"
                >
                    <Form.Item name="profilePic">
                        <Upload
                            listType="picture-circle"
                            fileList={fileList}
                            onPreview={handlePreview}
                            onChange={handleChange}
                            beforeUpload={() => false}
                        >
                            {fileList.length >= 1 ? null : uploadButton}
                        </Upload>
                    </Form.Item>

                    <Form.Item
                        label={<p className='auth_input_label'>FirstName</p>}
                        name="firstName"
                    >
                        <Input
                            size='large'
                            className='auth_input_ss'
                        />
                    </Form.Item>

                    <Form.Item
                        label={<p className='auth_input_label'>LastName</p>}
                        name="lastName"
                    >
                        <Input
                            size='large'
                            className='auth_input_ss'
                        />
                    </Form.Item>
                    <Form.Item
                        label={<p className='auth_input_label'>Email</p>}
                        name="email"
                        
                    >
                        <Input
                            size='large'
                            className='auth_input_ss'
                            readOnly
                        />
                    </Form.Item>
                    <div>
                        <CustomButton htmlType="submit"
                            title='Update'
                            loading={Update}
                            className="commonButton mt-12  text-center "
                        />
                    </div>
                </Form>

            </div>
        </>
    )
}

export default EditProfile